import { render, staticRenderFns } from "./Candidatos.vue?vue&type=template&id=7772a1fe&scoped=true"
import script from "./Candidatos.vue?vue&type=script&lang=js"
export * from "./Candidatos.vue?vue&type=script&lang=js"
import style0 from "./Candidatos.vue?vue&type=style&index=0&id=7772a1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772a1fe",
  null
  
)

export default component.exports